import React from "react";
import { useTranslation } from "hooks";
import { messageSW } from "workbox-window";
import { Button, Typography } from "../index";
import styles from "./NewAppVersion.module.css";

interface NewAppVersionProps {
  registration: ServiceWorkerRegistration;
}

const NewAppVersion: React.FC<NewAppVersionProps> = ({ registration }) => {
  const { t } = useTranslation();
  const reloadHandler = (): void => {
    if (registration && registration.waiting) {
      messageSW(registration.waiting, { type: "SKIP_WAITING" }).then(() => {});
      window.location.reload();
    }
  };

  return (
    <>
      <Typography variant="c1">{t("offline.newVersion")}</Typography>
      <Typography variant="c2" className={styles.label}>
        {t("offline.clickToReload")}
      </Typography>
      <Button onClick={reloadHandler} size="small">
        {t("offline.reload")}
      </Button>
    </>
  );
};

export default NewAppVersion;
